"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var LsgPicture_1 = require("../LsgPicture");

exports.RoundPicture = styled_components_1["default"](LsgPicture_1.LsgPicture)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 50%;\n  overflow: hidden;\n  padding-bottom: 100%;\n  background-size: cover;\n  background-position: center center;\n  height: auto;\n"], ["\n  border-radius: 50%;\n  overflow: hidden;\n  padding-bottom: 100%;\n  background-size: cover;\n  background-position: center center;\n  height: auto;\n"])));
var templateObject_1;